// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as AuthStore$PorterinFeature from "../store/AuthStore.mjs";
import * as ResendOtpApiModel$PorterinFeature from "../api-model/ResendOtpApiModel.mjs";

function apiModelToState(_model) {
  return {
          message: AuthStore$PorterinFeature.response_resend_otp_success
        };
}

function execute(json) {
  DeccoUtils$Catalyst.resolveResult(ResendOtpApiModel$PorterinFeature.t_decode(json), "ResendOtpEntityMapper.res");
  return {
          message: AuthStore$PorterinFeature.response_resend_otp_success
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
